import React, { useState, useEffect } from 'react';
import Stepper from './stepper';
import axios from 'axios';
import store from '../../store/store';
import _ from 'lodash';

interface icreateComponentSchema {
  tabName: string;
  editFields: Array<{
    label: string;
    name: string;
    type: 'text' | 'enumeration' | 'number';
    required?: boolean;
    disabled?: boolean;
    server?: boolean;
    values?: any;
    dependsOn?: string[];
    populate?: (state: any) => number;
    onChange?: string[];
    defaultValue?: any;
  }>;
}

export default function CreateParcel(props: any) {
  let createComponentSchema: icreateComponentSchema[] = props.schema;

  // set default value
  const newState: Record<string, any> = {};
  createComponentSchema?.[0].editFields?.map((v) => {
    newState[`${v.name}`] = v.defaultValue ?? undefined;
    return false;
  });

  // Bind dependency
  createComponentSchema = addDependency(createComponentSchema);

  const [state, setState] = useState(newState);

  const dataID = props.dataID;
  const apiURL = props.url;
  useEffect(() => {
    async function fetchAPI() {
      const url = `${apiURL}/${dataID}`;
      await axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${store.getState().auth.jwt}`,
          },
        })
        .then((res) => {
          setState(res.data);
        });
    }

    if (dataID) {
      fetchAPI();
    }
  }, [dataID, apiURL]);

  function updateForm(state: any) {
    setState(state);
    if (_.isFunction(props.getState)) {
      props.getState(state);
    }
  }

  return (
    <Stepper
      return={props.return}
      url={props.url}
      dataID={dataID}
      createComponentSchema={createComponentSchema}
      updateForm={updateForm}
      inheritState={state}
    />
  );
}

function addDependency(createComponentSchema: icreateComponentSchema[]): icreateComponentSchema[] {
  const dependArr = [];
  for (let i = 0; i < createComponentSchema.length; i++) {
    const c = createComponentSchema[i];
    if (c?.editFields?.length) {
      for (let j = 0; j < c.editFields.length; j++) {
        const editFields = c.editFields[j];
        if (editFields?.dependsOn?.length) {
          for (let k = 0; k < editFields.dependsOn.length; k++) {
            const name = editFields.dependsOn[k];
            dependArr.push({ name, onChage: editFields.name });
          }
        }
      }
    }
  }
  for (let i = 0; i < createComponentSchema.length; i++) {
    if (createComponentSchema[i]?.editFields?.length) {
      for (let j = 0; j < createComponentSchema[i].editFields.length; j++) {
        const name = createComponentSchema[i].editFields[j].name;
        const findOnchage = dependArr.filter((obj) => obj.name === name).map((obj) => obj.onChage);
        if (findOnchage?.length) {
          createComponentSchema[i].editFields[j].onChange = findOnchage;
        }
      }
    }
  }
  return createComponentSchema;
}
